import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu_home",
  "use": "icon-menu_home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu_home\">\n<path d=\"M3 6H21\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M3 12H21\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M3 18H21\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol